import * as React from 'react';
import { useTranslation } from 'react-i18next';
import css from './MealServiceAdditionalInfo.css';
var MealServiceAdditionalInfo = function () {
    var t = useTranslation('MealPage').t;
    return (React.createElement("div", { className: css.container },
        React.createElement("div", { className: css.wrapper, dangerouslySetInnerHTML: {
                __html: t('Pay attention! You can familiarize yourself with the ration of free in-flight meals included in the tariff on the website in the tab Meal')
            } })));
};
export default MealServiceAdditionalInfo;
